"use client";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <section className="relative overflow-hidden z-1">
      <div className="container mx-auto pt-6 sm:pt-9 md:pt-16 max-w-screen-2xl px-4 lg:px-6">
        <div className="grid grid-cols-12 justify-center items-center gap-y-8 gap-x-6 xl:gap-x-16 max-w-6xl mx-auto">
          <div className="col-span-12 xl:col-span-5 lg:col-span-6 md:col-span-12 sm:col-span-12">
            <div className="py-1.5 px-4 bg-primary/15 rounded-full w-fit">
              <p className="text-primary text-sm sm:text-lg font-bold">
                3D Visualization
              </p>
            </div>
            {/* Updated Heading: Larger and more descriptive */}
            <h1 className="text-black dark:text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mt-4 sm:mt-6">
              Transform Flat Labels into{" "}
              <span className="text-primary">Realistic 3D Cans</span> in
              Seconds.
            </h1>

            <Link to="/login">
              <button className="bg-primary text-white text-base sm:text-lg md:text-xl font-semibold py-3 sm:py-4 md:py-5 px-8 sm:px-10 md:px-12 rounded-full hover:bg-primary/90 hover:cursor-pointer mt-6 sm:mt-8 md:mt-10 transition-transform hover:scale-105">
                Get Started
              </button>
            </Link>
          </div>
          <div className="col-span-12 xl:col-span-7 lg:col-span-6">
            <img
              src="/images/hero/banner-image.png"
              alt="3D Can Preview"
              width={800} // Increased for quality
              height={800}
              className="w-full max-w-xs sm:max-w-sm md:max-w-md xl:max-w-lg mx-auto xl:ml-6 drop-shadow-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
